;(function ($) {

	$(document).ready(function(){

        

	});


	$(window).load(function(){


	});


	$(window).resize(function(){


	});



})(jQuery);
